import React, { useEffect } from "react";

export default function Footer() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://kit.fontawesome.com/c8c08aa244.js";
    script.async = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);
    return () => {
      // clean up the script when the component in unmounted
      document.body.removeChild(script);
    };
  }, []);

  return (
    <footer
      id="contact"
      className="w-full mt-3 border-t border-white/10 bg-[#0f172a] text-[#d1d5db]"
    >
      <div className="mx-auto max-w-5xl px-4 py-5">
        <div className="mb-4 h-px w-full bg-white/10" />
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row sm:items-center">
          <div className="max-w-xl text-center sm:text-left">
            <p className="text-sm font-light text-[#9ca3af]">
              Photography, design, and polished UI for modern brands.
            </p>
            <p className="text-xs text-[#94a3b8]">
              Built with React, Tailwind, and a keen eye for visual balance.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <a
              className="fa fa-linkedin fa-lg p-3 rounded-full bg-white/5 text-[#d1d5db] transition hover:bg-white/15 hover:text-white"
              href="https://www.linkedin.com/in/isaiah-sylvester-5184785b/"
              aria-label="LinkedIn"
            ></a>
            <a
              className="fa fa-github fa-lg p-3 rounded-full bg-white/5 text-[#d1d5db] transition hover:bg-white/15 hover:text-white"
              href="https://github.com/Isaiahsylnol"
              aria-label="GitHub"
            ></a>
            <a
              className="fa fa-codepen fa-lg p-3 rounded-full bg-white/5 text-[#d1d5db] transition hover:bg-white/15 hover:text-white"
              href="https://codepen.io/isaiahsylnol"
              aria-label="CodePen"
            ></a>
            <a
              className="fa fa-instagram fa-lg p-3 rounded-full bg-white/5 text-[#d1d5db] transition hover:bg-white/15 hover:text-white"
              href="https://www.instagram.com/capmatic/"
              aria-label="Instagram"
            ></a>
          </div>
        </div>
        <div className="mt-4 text-center text-xs text-[#8b96a7]">
          © 2025 Isaiah Sylvester
        </div>
      </div>
    </footer>
  );
}
